export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74')
];

export const server_loads = [0,3,7,9,10,11,12,13,15];

export const dictionary = {
		"/": [~18],
		"/auth/success": [~20,[2]],
		"/auth/[type]/[[clerk]]": [19,[2]],
		"/devices": [21],
		"/error": [22],
		"/experiments": [23],
		"/experiments/new": [34],
		"/experiments/[id]": [~24,[3]],
		"/experiments/[id]/ai-assistant": [25,[3,4]],
		"/experiments/[id]/ai-assistant/report": [26,[3,4]],
		"/experiments/[id]/plates": [27,[3,5]],
		"/experiments/[id]/plates/captured": [28,[3,5]],
		"/experiments/[id]/plates/in-progress": [29,[3,5]],
		"/experiments/[id]/plates/new": [30],
		"/experiments/[id]/plates/unprocessed": [31,[3,5]],
		"/experiments/[id]/quality-control": [32,[3,6]],
		"/experiments/[id]/reports": [33,[3]],
		"/jobs": [~35],
		"/jobs/new": [~38],
		"/jobs/[job]": [36,[7]],
		"/jobs/[job]/bulk-edit-details": [~37,[7]],
		"/library": [39,[8]],
		"/library/analysis-model": [40,[8,9]],
		"/library/analysis-model/[name]": [41,[8,9]],
		"/library/media": [42,[8,10]],
		"/library/media/[id]": [~43,[8,10]],
		"/library/organisms": [44,[8,11]],
		"/library/organisms/[identifier]": [~45,[8,11]],
		"/library/samples": [46,[8,12]],
		"/library/samples/[id]": [~47,[8,12]],
		"/library/treatments": [48,[8,13]],
		"/library/treatments/[id]": [~49,[8,13]],
		"/model-builder": [50,[14]],
		"/model-builder/[id]": [51,[14]],
		"/plate-designer": [~52],
		"/plate-designer/new": [~54],
		"/plate-designer/templates": [55,[15]],
		"/plate-designer/templates/new": [57,[15]],
		"/plate-designer/templates/[id]": [56,[15]],
		"/plate-designer/[id]": [~53],
		"/projects": [~58],
		"/projects/new": [60],
		"/projects/[project]": [59,[16]],
		"/reports": [~61],
		"/reports/new": [~64],
		"/reports/[report]": [~62],
		"/reports/[report]/edit": [~63],
		"/settings-v2/api-keys": [66,[17]],
		"/settings-v2/exports": [67,[17]],
		"/settings-v2/groups": [68,[17]],
		"/settings-v2/members": [69,[17]],
		"/settings-v2/tags": [70,[17]],
		"/settings-v2/templates": [~71,[17]],
		"/settings-v2/templates/new": [73,[17]],
		"/settings-v2/templates/[id]": [72,[17]],
		"/settings": [65],
		"/template": [74]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);